/* global __SERVER__ */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { func, string } from 'prop-types';
import { translate } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import { compose } from 'redux';

import {
  Button,
  Carousel,
  AppStoreBlackIcon,
  GooglePlayStoreIcon,
  ChevronRightIcon,
} from '@snapask/common-components';

import Parallax from '@dragonfruit/components/Parallax';
import Accordion from '@dragonfruit/components/Accordion';
import SEOHead from '@dragonfruit/components/SEOHead';
import Link from '@dragonfruit/components/Link';

import { HOME_DOWNLOAD_CLICK } from '@dragonfruit/constants/gtmEvents';
import { ANDROID, IOS } from '@dragonfruit/constants/appDownloadType';

import MainLayout from '@dragonfruit/layouts/MainLayout';

import { goToTutorSignupPage } from '@dragonfruit/redux/navigation';
import { actions as reportActions } from '@dragonfruit/redux/report';
import { sendGtmEvent } from '@dragonfruit/redux/googleTagManager';
import { getRegion } from '@dragonfruit/redux/locale';

import ReasonPanel from './components/ReasonPanel';
import Contact from './components/Contact';

import styles from './Tutors.scss';

import tutorKV from './images/img_tutor_kv.svg';
import tutorStep1 from './images/img_tutor_step01.svg';
import tutorStep2 from './images/img_tutor_step02.svg';
import tutorStep3 from './images/img_tutor_step03.svg';
import tutorRocket from './images/img_tutor_rocket.svg';
import tutorCloud from './images/img_tutor_cloud.svg';
import joinus from './images/img_tutor_joinus.svg';

const CarouselNextArrow = ({ onClick }) => (
  <div className={styles.next} onClick={onClick} />
);

CarouselNextArrow.defaultProps = {
  onClick: () => {},
};

CarouselNextArrow.propTypes = {
  onClick: func,
};

CarouselNextArrow.defaultProps = {
  onClick: () => {},
};

const CarouselPrevArrow = ({ onClick }) => (
  <div className={styles.prev} onClick={onClick} />
);

CarouselPrevArrow.defaultProps = {
  onClick: func,
};

CarouselPrevArrow.propTypes = {
  onClick: func,
};

CarouselPrevArrow.defaultProps = {
  onClick: () => {},
};

// @todo needs refactor, we don't need this function at all.
const getReasonList = testimonyObj =>
  testimonyObj.map(obj => ({
    ...obj,
    icon: <img src={obj.icon} />,
  }));

class Tutors extends Component {
  static propTypes = {
    goToTutorSignupPage: func.isRequired,
    sendGtmEvent: func.isRequired,
    t: func.isRequired,
    toggleReportForm: func.isRequired,
    userRegion: string.isRequired,
  };

  // hide for re-branding
  state = {
    // showVideoOverlay: true,
  };

  // onPlayVideo = () => {
  //   this.videoDOM.play();

  //   this.setState({
  //     showVideoOverlay: false,
  //   });
  // };

  handleSelectFaq = value => {
    const selectedFaq = this.state.selectedFaq === value ? '' : value;

    this.setState({
      selectedFaq,
    });
  };

  renderTestimony = ({ text, profileImage, name, tutorInfo }, key) => (
    <div key={key}>
      <div className={styles.testimony}>
        <p>{text}</p>
        <div className={styles.tutor}>
          <div
            className={styles.profilePicture}
            style={{
              backgroundImage: `url(${profileImage})`,
            }}
          />
          <div className={styles.remark}>
            <strong>{name}</strong>
            <div>{tutorInfo}</div>
          </div>
        </div>
      </div>
    </div>
  );

  render() {
    const { selectedFaq } = this.state;

    const {
      t,
      goToTutorSignupPage,
      toggleReportForm,
      sendGtmEvent,
      userRegion,
    } = this.props;

    const becomeTutorFaqs = t('tutorFaq:tutorFaq.content.become-tutor', {
      returnObjects: true,
      defaultValue: [],
    });

    const faqList = becomeTutorFaqs.length ? becomeTutorFaqs[0].questions : [];

    const testimoniesList = t('tutor.testmonies', {
      returnObjects: true,
      defaultValue: [],
    });
    const signupDocument = t('tutor.needs', {
      returnObjects: true,
      defaultValue: [],
    });

    const getSignupDocumentListByName = name =>
      signupDocument[name].content
        .filter(text => text !== '-')
        .map((profileItem, index) => <li key={index}>{profileItem}</li>);

    const reasonList = getReasonList(
      t('tutor.reasons', {
        returnObjects: true,
        defaultValue: [],
      })
    );

    const onIosDownloadClick = () => {
      sendGtmEvent({
        eventName: HOME_DOWNLOAD_CLICK,
        data: {
          region: userRegion,
          type: IOS,
        },
      });
    };

    const onAndroidDownloadClick = () => {
      sendGtmEvent({
        eventName: HOME_DOWNLOAD_CLICK,
        data: {
          region: userRegion,
          type: ANDROID,
        },
      });
    };

    const seoComponent = (
      <SEOHead
        path="become-a-tutor"
        title={t('seo:seo.tutor.title')}
        description={t('seo:seo.tutor.description')}
      />
    );

    if (__SERVER__) {
      return seoComponent;
    }

    return (
      <MainLayout showFooter>
        {seoComponent}
        <section className={styles.sectorOne}>
          <div className={styles.top}>
            <div className={styles.left}>
              <h1
                className={styles.heading}
                dangerouslySetInnerHTML={{
                  __html: `${t('tutor.heading')}`,
                }}
              />
              <h4
                className={styles.remarkOne}
                dangerouslySetInnerHTML={{
                  __html: `${t('tutor.description')}`,
                }}
              />
              <div className={styles.applyTutor}>
                <Button
                  onClick={goToTutorSignupPage}
                  text={t('tutor.apply')}
                  primary
                />
              </div>
              <p className={styles.remarkTwo}>{t('tutor.getSnapask')}</p>
              <div className={styles.getSnapask}>
                {/* get on iphone */}
                <Link
                  to={t('common:common.ios_download_link')}
                  newTab
                  className={styles.sectionOneBtn}
                  onClick={onIosDownloadClick}
                >
                  <AppStoreBlackIcon width={142} height={45} />
                </Link>

                {/* get on android */}
                <Link
                  to={t('common:common.android_download_link')}
                  newTab
                  className={styles.sectionOneBtn}
                  onClick={onAndroidDownloadClick}
                >
                  <GooglePlayStoreIcon width={142} height={45} />
                </Link>
              </div>
            </div>
            <div className={styles.right}>
              <img src={tutorKV} />
            </div>
          </div>
        </section>

        <section className={styles.sectorTwo}>
          <div className={styles.reasonPanel}>
            <ReasonPanel
              title={t('tutor.reasonsMustBeTutors')}
              list={reasonList}
            />
          </div>
          <h3>{t('tutor.step.title')}</h3>
          <div className={styles.tutorialPanel}>
            <div className={styles.panel}>
              <div className={styles.index}>1</div>
              <img src={tutorStep1} />
              <h5>{t('tutor.step.one.onlineRegister')}</h5>
              <p>{t('tutor.step.one.createAccount')}</p>
            </div>

            <div className={styles.panel}>
              <div className={styles.index}>2</div>
              <img src={tutorStep2} />
              <h5>{t('tutor.step.two.uploadCert')}</h5>
              <p>{t('tutor.step.two.detail')}</p>
            </div>

            <div className={styles.panel}>
              <div className={styles.index}>3</div>
              <img src={tutorStep3} />
              <h5>{t('tutor.step.three.startTeaching')}</h5>
              <p>{t('tutor.step.three.detail')}</p>
            </div>
          </div>
        </section>

        <section className={styles.sectorThree}>
          <h3 className={styles.title}> {signupDocument.title}</h3>
          <div className={styles.documentWrapper}>
            <ul className={styles.documentList}>
              <h5 className={styles.title}>{signupDocument.profile.title}</h5>
              {getSignupDocumentListByName('profile')}
            </ul>
            <ul className={styles.documentList}>
              <h5 className={styles.title}>{signupDocument.documents.title}</h5>
              {getSignupDocumentListByName('documents')}
            </ul>
            <ul className={styles.documentList}>
              <h5 className={styles.title}>{signupDocument.time.title}</h5>
              {getSignupDocumentListByName('time')}
            </ul>
          </div>
          <div className={styles.registerWrapper}>
            <a onClick={goToTutorSignupPage} className={styles.registerLink}>
              {signupDocument.register.text}
              <ChevronRightIcon
                className={styles.arrowIcon}
                width={26}
                height={26}
              />
            </a>
          </div>
        </section>
        <section className={styles.sectorFour}>
          <div className={styles.cloud}>
            <Parallax
              image={tutorRocket}
              imageStyle={{
                width: '6.25rem',
                bottom: '392px',
                right: '100px',
              }}
            />
            <img className={styles.cloudImg} src={tutorCloud} />
          </div>

          <div className={styles.container}>
            <h3>{t('tutor.tutorSpeaks')}</h3>
            <Carousel
              settings={{
                dots: true,
                speed: 500,
                nextArrow: <CarouselNextArrow />,
                prevArrow: <CarouselPrevArrow />,
              }}
            >
              {testimoniesList.map((testimony, key) =>
                this.renderTestimony({ ...testimony }, key)
              )}
            </Carousel>
          </div>
        </section>

        <section className={styles.sectorFive}>
          <div className={styles.impacts}>
            <div className={styles.column}>
              <div className={styles.impactRemark}>
                <h4 className={styles.participateTo}>
                  {t('tutor.canAlsoParticipateTo')}
                </h4>
              </div>
              <div className={styles.impactRemark}>
                <h5>{t('tutor.deepSharing')}</h5>
                <p>{t('tutor.participateEvents')}</p>
              </div>
              <div className={styles.impactRemark}>
                <h5>{t('tutor.createPracticeProblems')}</h5>
                <p>{t('tutor.createRawPracticeProblem')}</p>
              </div>
            </div>

            <div className={styles.column}>
              <div className={styles.impactRemark} />
              <div className={styles.impactRemark}>
                <h5>{t('tutor.shareExperience')}</h5>
                <p>{t('tutor.writeLearningBlog')}</p>
                <a href={t('navbar:navbar.link.academyLink')}>
                  {t('tutor.readMoreBlog')}
                </a>
              </div>
              <div className={styles.impactRemark} />
            </div>
          </div>
        </section>

        <section className={styles.sectorSix}>
          <div className={styles.faqPanel}>
            <h4>{t('tutor.commonProblem')}</h4>

            {!!faqList.length && (
              <Accordion>
                {faqList.map((faq, index) => (
                  <Accordion.Tab
                    key={index}
                    label={faq.q}
                    value={faq.link}
                    onClick={this.handleSelectFaq}
                    selected={selectedFaq === faq.link}
                  >
                    <ReactMarkdown
                      source={faq.a}
                      renderers={{
                        Link: props => (
                          <a onClick={toggleReportForm}>{props.children}</a>
                        ),
                      }}
                    />
                  </Accordion.Tab>
                ))}
              </Accordion>
            )}
          </div>
        </section>

        <section className={styles.sectorSeven}>
          <div className={styles.left}>
            <h4> {t('tutor.recrutingYou')}</h4>
            <p
              dangerouslySetInnerHTML={{
                __html: `${t('tutor.contributeToEducation')}`,
              }}
            />
            <div className={styles.applyButton}>
              <Button
                onClick={goToTutorSignupPage}
                text={t('tutor.applyToJoin')}
                primary
              />
            </div>
          </div>
          <div className={styles.right}>
            <img className={styles.rocket} src={joinus} />
          </div>
        </section>

        <section className={styles.sectorEight}>
          <Contact />
        </section>
      </MainLayout>
    );
  }
}

export default compose(
  connect(state => ({ userRegion: getRegion(state) }), {
    goToTutorSignupPage,
    toggleReportForm: reportActions.toggleReportForm,
    sendGtmEvent,
  }),
  translate(['tutor', 'navbar', 'common', 'seo', 'tutorFaq'])
)(Tutors);



// WEBPACK FOOTER //
// ./app/containers/Tutors/Tutors.jsx